<template>
  <div id="Allergies">
<PetButtonDropDown
            :img_src="require('@/assets/svg/pet-card-tabs/health/allergies-colored.svg')"
            :name="'Allergies'"
            :expanded="true"
            :gray_text="'My Allergies'"
            :bg_color="'rgba(98, 102, 240, 0.1)'"
        >
    <div class="details-container" v-if="!addingAllergy && allergy_que.length == 0 && loading == false">
    
      <div class="no-details-box">
        <div class="pic-upload"
          :style="{'background-image': 'url(' + require('@/assets/svg/pet-card-icon/dog-bowl.svg') + ')'}">
        </div>
        <p class="gallery-text">{{pet_data.name}} does not have any allergies.</p>
      </div>
    </div>

    <div class="menu-group">
      <XyzTransitionGroup xyz="fade left-100%" v-if="allergy_que.length > 0 && !loading">
      <div v-for="(mu, idx ) in allergy_que" :key="idx" class="menu-box" >
          <div :class="{'menu-item-bar':true,'menu-rounded-top':idx === 0,'menu-rounded-bottom': idx === allergy_que.length - 1,}" >
            <span class="icon-text">
              {{mu}}
            </span>
            <img @click="deleteAllergyQue(idx)"
            v-if="editablePage"
            src="@/assets/icons/delete.svg" class="setting-icon"/>
          </div>

          <div class="menu-item-bar xyz-nested" xyz="fade left-100%"
              v-if="addingAllergy == true && idx == allergy_que.length-1" >
            <input class="menu-input" v-model="new_allergyen" placeholder="Enter an allergy">
            <button class="edit-allergy">
              <img src="@/assets/icons/floppy.svg" @click="addAllergyQue()"/>
            </button>
            <button class="edit-allergy" v-if="editablePage">
              <img @click="deleteAllergy2()" src="@/assets/icons/delete.svg"/>
            </button>
          </div>

        </div>

        <div class="menu-box" key="nav-menu">
          <div v-if="load_more && all_allergy_data && all_allergy_data.length > 5" class="menu-item-bar menu-button-nav menu-rounded-bottom" @click="togglePagination()">
                Load More
          </div>
          <div v-else-if="all_allergy_data && all_allergy_data.length > 5" class="menu-item-bar menu-button-nav menu-rounded-bottom" @click="togglePagination()">
                Show Less
          </div>
        </div>

      </XyzTransitionGroup>

      
      <XyzTransition>
        <!-- actives if this is their FIRST allergy -->
        <div class="menu-item-bar xyz-nested"  xyz="stagger-2 narrow-100%" v-if="addingAllergy == true && allergy_que.length == 0">
          <input class="menu-input" v-model="new_allergyen" placeholder="Enter an allergy">
          <button class="edit-allergy">
            <img src="@/assets/icons/floppy.svg" @click="addAllergyQue()"/>
          </button>
          <button class="edit-allergy" v-if="editablePage">
            <img @click="deleteAllergy2()" src="@/assets/icons/delete.svg"/>
          </button>
        </div>
      </XyzTransition>

      <!-- <div class="allergy-cell add-new-allergy" v-if="addingAllergy == true">
        <div class="input-group">
          <input v-model="new_allergyen" placeholder="Enter an allergy">
        </div>
        <button class="btn add-btn" @click="addAllergyQue()" >Add</button>
      </div> -->

      <div
        v-if="editablePage"
        class="btn  allergy-btn"
        @click="activateNewAllergy()">
        Add an Allergy
      </div>
    </div>
    </PetButtonDropDown>
  </div>
</template>

<script>
import {db} from '@/_firebase/init'
import {mapState, mapMutations} from 'vuex'
import PetButtonDropDown from "@/petprofile/components/pet/tabs/PetButtonDropDown"

export default {
  name: 'Allergies',
  components:{
    PetButtonDropDown
  },
  props: ['editablePage'],
  data(){
    return{
      loading: false,
      pet_id: this.$route.params.pet_id,
      processing: false,
      addingAllergy: false,
      userdata: {},
      pets_owned: [],
      pets:[{photo:'', name: ''}],
      allergy_que: [],
      new_allergy_que: [],
      new_allergyen: '',
      load_more:true,
      all_allergy_data: [],
      pet_data:{allergies:[]}
      }
  },
  methods:{
    activateNewAllergy(){
      this.addingAllergy = true
    },
    togglePagination(){
      if(this.allergy_que.length > 5){
        this.allergy_que = this.all_allergy_data.slice(0,5)
      }else{
        this.allergy_que = this.all_allergy_data
      }
      this.load_more = !this.load_more;
    },
    ...mapMutations(['SET_PETDATA']),
    gotoRoute(rotue){
      this.$router.push({name: rotue})
    },
    async deleteAllergyQue(a_id){
      this.allergy_que.splice(a_id, 1);
      this.pet_data['allergies'] = this.allergy_que
      let data = {
        allergies: this.allergy_que
      }
      await db.collection('pets').doc(this.pet_id).update( data);
      // console.log(this.allergy_que)
    },
    deleteAllergy2(){
      this.addingAllergy = false
    },
    async getPetData(){
      this.loading = true
      const petRef = db.collection('pets').doc(this.pet_id);
      const pet_doc = await petRef.get();
      this.pet_data = pet_doc.data()
      this.$store.commit('SET_PETDATA', this.pet_data)
      this.all_allergy_data = this.pet_data.allergies;
      if(this.all_allergy_data.legth <= 5){
        this.load_more = false;
        this.allergy_que = this.all_allergy_data;
      }else{
        this.load_more = true;
        this.allergy_que = this.all_allergy_data.slice(0,5);
      }
      this.loading = false
      return this.pet_data
    },
    async addAllergyQue(){
      if(this.new_allergyen){
        this.allergy_que.push(this.new_allergyen);
        this.new_allergyen =''
        this.addingAllergy = false
        this.pet_data['allergies'] = this.allergy_que
        let data = {
          allergies: this.allergy_que
        }
        this.$store.commit('SET_PETDATA', this.pet_data)
        await db.collection('pets').doc(this.pet_id).update( data);
      }
      // console.log(this.allergy_que)
    },
  },
  computed:{
    ...mapState([
      'userID', 'pet_data'
    ]),
  },
  created(){
    this.getPetData()
  },
  // mounted(){
  //   this.allergy_que = this.pet_data.allergies
  // }
}
</script>
<style scoped>
#Allergies{
  margin: auto;
  padding-bottom: 1rem;
}
.top-btn .upload-btn{
  width: 3rem;
  height: 3rem;
  position: absolute;
  border-radius: 100%;
  opacity:0;
  top:0;
  left:0;
}
.menu-group{
  margin: 0 auto;
}
.allergy-btn{
  margin-top: 3rem;
  width: 60%;
  transition: 1s;
}
.allergy-cell{
  width: 60%;
  display:flex;
  justify-content: space-between;
  align-items:center;
  font-size: .9rem;
  margin: 1rem auto;
}

.menu-button-nav{
  display: flex !important;
  color: var(--primary);
  justify-content: center !important;
  align-items: center !important;
  text-align: center !important;
  margin-top: 1rem;
}
.menu-rounded-top{
  border-top-left-radius: 12px;
  border-top-right-radius: 12px;
}
.menu-rounded-bottom{
  border-bottom-left-radius: 12px;
  border-bottom-right-radius: 12px;
}
.menu-item-bar{
    max-height: 3.5rem;
    background-color: #fff;
    font-size: 1rem;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    font-weight: bold;
    transition: 1s;
    margin: 1px auto;
    padding: 8px 18px;
    background: #fff;
    border: 1px solid rgba( 255, 255, 255, 0.18 );
}
/* .menu-item-bar:hover{
  transform: translateY(-10px);
} */
.setting-icon{
  width: 1.5rem;
  height: 1.5rem;
  cursor: pointer;
  margin: 0 .5rem;
}
.icon-text{
    display: flex;
    font-weight: 400;
    font-size: 16px;
    text-transform: capitalize;
    color: #00133D;
    line-height: 24px;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
}
/* .icon-text img{
  width: 1.8rem;
  height: 1.8rem;
} */

.selected{
  transform: rotate(90deg);
}
.processing-box{
  bottom: 1rem;
}
.processing-box img{
  width: 3rem;
}
.edit-allergy{
  width: 1.2rem;
  margin: 0 .5rem;
  background: none;
  border: none;
  outline:none;
  cursor:pointer;
  transition:1s;
}
.edit-allergy img{
  width: 100%;
}
.x-close{
  font-size: 2rem;
}
.menu-input{
    margin: 0 auto;
    width: 65%;
    outline:none;
    border: none;
    background: transparent;
    width: 100%;
    font-size: .8rem;
    font-weight: bold;
    font-family: "Altis";
  }
.add-btn{
  border: none;
  border-radius: 10px;
  font-size: 1rem;
  text-align: center;
  padding: .7rem;
  margin: 1rem auto;
  outline: none;
  color: #fff;
}

.no-details-box{
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items:center;
}
.no-details-box img{
  width: 8rem;
  transition: 1s;
  margin: 2rem auto;
}
.pic-upload{
  position: relative;
  width: 12rem;
  height: 12rem;
  margin: 0 auto;
  text-align:center;
  overflow:hidden;
  background-position: center;
  background-repeat: no-repeat;
  background-size: 70%;
}

.gallery-text{
  font-weight: bold;
  color: #adb6e1;
  text-align:center;
  font-size: 1.3rem;
}
.pic-upload:hover img{
  transform: translateY(-6px);
}

body[data-theme='dark']  #Allergies{
  background-color: #222;
  color: var(--text-dark);
  border-color: var(--text-dark);
}
body[data-theme='dark']  .menu-item-bar{
  background-color: #555
}
/*mobile base */
@media only screen and (max-width: 600px) {
  .menu-group{
    text-align:center;
    /* min-height: 90vh; */
  }
  .menu-item-bar{
   margin: 1px auto;
  }
  .setting-icon{
    width: 1rem;
    height: 1rem;
  }

}
@media only screen and (max-width: 400px){
}
</style>
